import { createApp } from "vue";
import { createPinia } from 'pinia';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import * as Sentry from "@sentry/vue";
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import Tooltip from 'primevue/tooltip';

import PrimeVue from 'primevue/config';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import 'primeicons/primeicons.css';

import 'bootstrap/dist/js/bootstrap.js';
import '@/bootstrapSettings.scss';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '@vueform/multiselect/themes/default.scss';

import App from "./App.vue";
import router from "./router";

dayjs.extend(utc);

const BlueAura = definePreset(Aura, {
  semantic: {
    primary: {
      50:  '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',  
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
  },
});

const app = createApp(App);
const pinia = createPinia();

pinia.use(piniaPluginPersistedstate);

if (process.env.VUE_APP_YANDEX_METRICA === 'true') {
    (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
    m[i].l=1*new Date();
    for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
    k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
    (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

    ym(97436805, "init", {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true
    });

    // Add the noscript part to ensure tracking for users with JavaScript disabled
    const noscript = document.createElement('noscript');
    noscript.innerHTML = '<div><img src="https://mc.yandex.ru/watch/97436805" style="position:absolute; left:-9999px;" alt="" /></div>';
    document.body.appendChild(noscript);
}

if (process.env.SENTRY_DSN) {
    Sentry.init({
        app,
        dsn: `https://${process.env.SENTRY_DSN}@sentry.mars-saz.ru/3`,
        integrations: [
            Sentry.replayIntegration({
                maskAllText: false,
            })
        ],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
}

app.directive('tooltip', Tooltip);
app.use(pinia);
app.use(PrimeVue, {
  theme: {
    preset: BlueAura,
    options: {
      darkModeSelector: 'none'
    }
  }
});
app.use(router).mount("#app");

if (process.env.BITRIX_WIDGET_URL) {
  (function(w, d, u) {
    try {
      var s = d.createElement('script');
      s.async = true;
      s.src = u + '?' + ((Date.now() / 60000) | 0);
      var h = d.getElementsByTagName('script')[0];
      h.parentNode.insertBefore(s, h);
    } catch (e) {
      console.warn('Failed to load Bitrix24 widget:', e);
    }
  })(window, document, process.env.BITRIX_WIDGET_URL);
}
